import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms74e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms74e/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dteyear: (typeof searchParams.year !== 'undefined' ? searchParams.year : ''),
        p_numclseq: (typeof searchParams.numclseq !== 'undefined' ? searchParams.numclseq : ''),
        p_nummemo: (typeof searchParams.nummemo !== 'undefined' ? searchParams.nummemo : ''),
        p_codcours: (typeof searchParams.codcours !== 'undefined' ? searchParams.codcours : ''),
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : '')
      }
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hrms74e/index', { params: sendParams })
  },
  getIndexAddInline ({ searchParams, param }) {
    if (isMock) return generator(mocker.indexAddInline(param))
    const sendParams = {
      p_codempid_query: param.codempid,
      p_nummemo: searchParams.nummemo,
      p_codcours: searchParams.codcours,
      p_dteyear: searchParams.year,
      p_numclseq: searchParams.numclseq
    }
    return instance().get(endpoint + '/hrms74e/indexAddInline', { params: sendParams })
  },
  getDetail (searchParams) {
    const params = searchParams.p_dteyear + '/' + searchParams.p_dtemonth + '/' + searchParams.p_codcours + '/' + searchParams.p_codempid_query
    if (isMock) return generator(mocker.detail())
    return instance().get(endpoint + '/hrms74e/detail/' + params)
  },
  // postIndexSave (dataRowsHasFlg) {
  //   var params = []
  //   for (var i = 0; i < dataRowsHasFlg.length; i++) {
  //     var dataRow = dataRowsHasFlg[i]
  //     params.push({
  //       'p_dteyear': dataRow.p_dteyear,
  //       'p_codcours': dataRow.p_codcours,
  //       'p_codcomp': dataRow.p_codcomp,
  //       'p_numlvl': dataRow.p_numlvl,
  //       'p_nummemo': dataRow.p_nummemo,
  //       'p_codempid': dataRow.codempid,
  //       'p_codpos': dataRow.codpos,
  //       'p_codplan': dataRow.codplan,
  //       'p_staappr': dataRow.staappr,
  //       'p_flgconf': dataRow.flgconf,
  //       'p_flgtrn': dataRow.v_flgtrn,
  //       'p_flg': dataRow.v_flg
  //     })
  //   }
  //   var saveParams = {
  //     'p_param': JSON.stringify(dataRowsHasFlg)
  //   }
  //   if (isMock) return generator(mocker.save())
  //   return instance().post(endpoint + '/hrms74e/indexSave', saveParams)
  // },
  postSendApprove (sendParams) {
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hrms74e/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms74e/index.js